<div *ngIf="ristorazioneService.getLoading()">
    <div class="loader-app-component">
        <!-- <img src="../assets/img/sdg_spinner.gif" alt="Servizi di Governo" style="color: blue;"> -->
    </div>
</div>

<router-outlet></router-outlet>

